export interface RecruiterSettings {
  userId: string;

  // Persisted preferences
  emailNotifications: boolean;
  pushNotifications: boolean;
  productAnnouncements: boolean;
  darkTheme: boolean;
  compactTables: boolean;
  autoplayMedia: boolean;
  language: string;

  // Account, projected from the recruiter record. Read only on this screen.
  firstName: string | null;
  lastName: string | null;
  email: string | null;
  designation: string | null;
  companyAdminUser: boolean;
  recruiterStatus: boolean;

  // Company, projected from the company record. Read only on this screen.
  companyId: string | null;
  companyName: string | null;
  companyDomain: string | null;
  companyLogoUrl: string | null;
  industry: string | null;
  gstNumber: string | null;
  headquartersLocation: string | null;
  subscriptionPlanName: string | null;
  subscriptionPlanStatus: string | null;

  // Security, read only on this screen.
  activeSessions: number;

  createdAt?: string;
  updatedAt?: string;
}

/** Only the fields this screen is allowed to write. */
export interface RecruiterSettingsUpdate {
  emailNotifications?: boolean;
  pushNotifications?: boolean;
  productAnnouncements?: boolean;
  darkTheme?: boolean;
  compactTables?: boolean;
  autoplayMedia?: boolean;
  language?: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export interface ChangePasswordResponse {
  passwordChanged: boolean;
  otherSessionsRevoked: number;
}

export const LANGUAGE_OPTIONS: { value: string; label: string }[] = [
  { value: "en", label: "English" },
];
